import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';

export function PrimeBenefitBanner({ bannerTextKey, classAttribute, pillCmsKey }) {
    return (
        <div className={`odf-box odf-space-inner-m odf-space-outer-right-m odf-space-outer-top-l ${classAttribute} odf-bg-prime-informative-message`}>
            <div className="odf-flex-container-row">
                <div className="odf-message-icon odf-space-inner-top-s">
                    <span className="odf-logo-prime-negative odf-logo-prime-negative-xs odf-space-outer-left-l" />
                </div>
                <div className="odf-space-outer-left-xl odf-text-mono-color-09">
                    <div className="odf-flex-container-row">
                        <div className="odf-flex-item">
                            <CMS id={bannerTextKey} dangerouslySetInnerHTML />
                        </div>

                        <div className="odf-flex-item odf-space-inner-bottom-l">
                            <div className="odf-pills odf-pills-prime open">
                                <p className="odf-bold"><CMS id={pillCmsKey} dangerouslySetInnerHTML /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PrimeBenefitBanner.propTypes = {
    bannerTextKey: PropTypes.string.isRequired,
    pillCmsKey: PropTypes.string.isRequired,
    classAttribute: PropTypes.string,
};
